module.exports = class CfdCompetency extends EcCompetency {
	subtype = null;
};
